import { Strings } from '@app/constants';
import { IEducationInfoSchema } from '../types';
import { InternalSubCard } from '@app/components/card';

interface EducationInfoProps {
  userData: IEducationInfoSchema;
}

const HigherEducationInfo = ({ userData }: EducationInfoProps) => {
  const graduationDetails = userData?.education ?? [
    {
      schoolCollegeInstitute: '',
      degreeDiplomaCertificate: '',
      specialization: '',
      dateOfCompletion: '',
    },
  ];
  const subCards = graduationDetails.map((graduationDetail, index) => ({
    fields: [
      Strings.education.schoolCollegeInstitute,
      Strings.education.degreeDiplomaCertificate,
      Strings.education.specialization,
      Strings.education.dateOfCompletion,
    ],
    data: [
      graduationDetail.name || 'NA',
      graduationDetail.degree || 'NA',
      graduationDetail.specialization || 'NA',
      graduationDetail.passedOutYear || 'NA',
    ],
  }));

  return (
    <>
      <InternalSubCard
        title={Strings.education.higherEducation}
        height={'270px'}
        subCards={subCards}
        iconImg="ic_higherEducation"
      />
    </>
  );
};

export { HigherEducationInfo };
